import locales from './locales.json';

export const LOCALES = {
    ...locales,
};
